/**
 * Shared enter animation for floating in-page panels and banners (bulk-action
 * bars, compose/chat panels, floating notices) — surfaces that mount into the
 * page rather than into a react-aria overlay, so they animate on mount.
 *
 * 200ms ease-out per VISUAL_STYLE_GUIDE.md § Motion (expand/collapse budget),
 * gated by `motion-safe:`. Pick the variant matching the edge the panel
 * enters from. Do NOT respell this recipe at call sites.
 */

export const FLOATING_PANEL_ANIM_FROM_BOTTOM =
  'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2 motion-safe:duration-200 motion-safe:ease-out';

export const FLOATING_PANEL_ANIM_FROM_TOP =
  'motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-top-2 motion-safe:duration-200 motion-safe:ease-out';
